import { render, staticRenderFns } from "./PasswordResetRoute.vue?vue&type=template&id=c090718e"
import script from "./PasswordResetRoute.vue?vue&type=script&lang=js"
export * from "./PasswordResetRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports